//Imports node_modules
import React, { useState } from "react";

//Variaveis inicias
const initialState = {

    //Status
    messageModalStatus: false,
    formModalStatus: false,
    loadingModalStatus: false,
    pinStatus: false,

    //Modal Variavels
    modalInfo: { modalTitle: 'Informação' },
}

export const globalModals = React.createContext(initialState)

const GlobalModals = params => {
    const [state, setState] = useState(initialState)

    //Show Modals
    function showMessageModal(receivedModalInfo) {
        setState({
            ...state,
            messageModalStatus: true,
            modalInfo: receivedModalInfo,

            //Reseta o resto dos modals
            formModalStatus: false,
            pinStatus: false,
            loadingModalStatus: false,
        })
    }

    function showPinModal() {
        setState({
            ...state,
            pinStatus: true,
        })
    }

    function showFormModal(receivedModalInfo) {
        setState({
            ...state,
            formModalStatus: true,
            modalInfo: receivedModalInfo,

            //Reseta o resto dos modals
            messageModalStatus: false,
            loadingModalStatus: false,
        })
    }

    function showLoadingModal() {
        setState({
            ...state,
            loadingModalStatus: true,

            //Reseta o resto dos modals
            messageModalStatus: false,
            formModalStatus: false,

        })
    }

    //Dismiss Modals
    function dismisMessageModal() {
        setState({
            ...state,
            messageModalStatus: false,
            loadingModalStatus: false,
            pinStatus: false,
            modalInfo: { hidden: true }
        })
    }
    function dismisFormModal() {
        setState({
            ...state,
            formModalStatus: false,
            messageModalStatus: false,
            loadingModalStatus: false,
            modalInfo: { hidden: true }
        })
    }
    function dismisLoadingModal() {
        setState({
            ...state,
            loadingModalStatus: false,
            modalInfo: { hidden: true }
        })
    }
    function dismissPinModal(){
        setState({
            ...state,
            pinStatus: false,
            modalInfo: { hidden: true }
        })
    }


    return (
        <globalModals.Provider value={{

            //---Variaveis
            //Status
            messageModalStatus: state.messageModalStatus,
            formModalStatus: state.formModalStatus,
            loadingModalStatus: state.loadingModalStatus,
            pinStatus: state.pinStatus,

            //Modal Variavels
            modalInfo: state.modalInfo,
            //---Fim Variaveis

            //---Funções
            //t = text, n = number, a = object/array b= boolean, d= date
            //Show Modals
            ShowMessageModal: (receivedModalInfo) => showMessageModal(receivedModalInfo),
            ShowFormModal: (receivedModalInfo) => showFormModal(receivedModalInfo),
            ShowLoadingModal: () => showLoadingModal(),
            ShowPinModal: () => showPinModal(),


            //Dismiss Modals
            DismisMessageModal: _ => dismisMessageModal(),
            DismisFormModal: _ => dismisFormModal(),
            DismisLoadingModal: _ => dismisLoadingModal(),
            DismissPinModal: _ => dismissPinModal(),

            //---Fim Funções
        }}>
            {params.children}
        </globalModals.Provider>
    )
}

export default GlobalModals